import ReactTools from './Misc/ReactTools';
import UIManager from './UiManager';

/**
 * Makes creating a React UI overlay simple
 */
export class ReactUI {
	/**
	 * Use this in the reducer area
	 */
	public reducer(state: any, action: any): any {
		var result = ReactTools.generalReducer(state, action);
		switch (action.type) {
		case 'updateProps':
			var props = state.uiProps ? {...state.uiProps} : {};
			props[action.value.propName] = action.value.propValue;
			result = {...state, uiProps: props};
			break;
		case 'initializeProps':
				
			result = {...state, uiProps: action.value};
			break;
		case 'stopResetting':
			result = {...state};
			for(var prop in result.uiProps) {
				if(state.uiProps[prop].parameters) {
					result.uiProps[prop].parameters.reset = false;
				}
			}
			break;
		}
		return result;
	}

	/**
	 * Registers a UI
	 * @param uiManager A reference to the UI manager 
	 * @param dispatch A reference to the dispatch
	 * @param uiName The name of the UI
	 */
	public registerUI (uiManager: UIManager, dispatch: any, uiName: string): void {
		uiManager.registerUI(uiName, (props: any) => {
			dispatch({
				type: 'updateProps',
				value: {
					propName: uiName,
					propValue: props
				}
			});  
		});
	}

	/**
	 * Call this every time in useEffect. Resets a UI if it needs to
	 */
	public validateUIPrps(state: any, dispatch: any): void {
		if(state.uiProps) {
			var shouldReset = false;
			for(var prop in state.uiProps) {
				if(state.uiProps[prop].parameters && state.uiProps[prop].parameters.reset) {
					shouldReset = true;
				}
			}

			if(shouldReset) {
				dispatch({
					type: 'stopResetting'
				});
			}
		}
	}

	/**
	 * Call this only once through the lifespan of the component
	 * @param dispatch A reference to the dispatch
	 * @param inGameUINames A reference to the object that contains all UI names (a property per UI name)
	 */
	public init(dispatch: any, inGameUINames: any): void {
		var initialProps: any = {};
    
		for(var el in inGameUINames) {
			initialProps[el] = {};
		}
		dispatch({
			type: 'initializeProps',
			value: initialProps
		}); 
	}

	/**
	 * Renders a component
	 * @param state A reference to the state
	 * @param uiName The UI name to use
	 * @param comp The component to render
	 */
	public renderUiComponent (state: any, uiName: string, comp: any): any {
		return state.uiProps[uiName] && state.uiProps[uiName].isVisible ? comp : null;
	}
}